import { PhoneMock } from "../PhoneMock";
import { SpinningIco } from "../SpinningIco";
import { Wordmark } from "../Wordmark";
import { WhistllLogo } from "../WhistllLogo";

/**
 * Brand screen: opens the gallery with a live spinning icosahedron. Same
 * geometry we use for the player level badge inside the app, pulled out as
 * a standalone brand frame so the gallery leads with motion rather than four
 * static screenshots.
 */
export function BrandIcoMock({ className }: { className?: string }) {
  return (
    <PhoneMock className={className}>
      {/* Status bar */}
      <div className="flex items-center justify-between px-6 pt-4 pb-1 text-[10px] font-semibold">
        <span>9:41</span>
        <span className="flex items-center gap-1 text-[9px]">● ● ●</span>
      </div>

      {/* Soft volt wash behind the polyhedron */}
      <div className="relative flex h-full w-full flex-col items-center justify-center px-6 pb-16">
        <div
          aria-hidden
          className="absolute left-1/2 top-[44%] h-[260px] w-[260px] -translate-x-1/2 -translate-y-1/2 rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(255,98,0,0.22) 0%, rgba(255,98,0,0.06) 45%, rgba(13,17,23,0) 72%)",
            filter: "blur(2px)",
          }}
        />

        {/* Logomark + wordmark up top */}
        <div className="relative z-10 flex items-center gap-2 pt-2">
          <WhistllLogo size={22} color="#FF6200" />
          <Wordmark size="text-lg" className="text-[#F5F5DC] tracking-[0.18em]" />
        </div>

        {/* Spinning icosahedron centre stage */}
        <div className="relative z-10 mt-6 flex items-center justify-center">
          <SpinningIco size={220} />
        </div>

        {/* Tagline */}
        <div className="relative z-10 mt-4 max-w-[220px] text-center">
          <p className="text-[13px] font-black leading-tight text-[#F5F5DC]">
            Built for{" "}
            <span className="text-[#FF6200]">real hoopers</span>.
          </p>
          <p className="mt-1.5 text-[10px] leading-snug text-[#8899A6]">
            Book, run, compete. One app, five countries, one game.
          </p>
        </div>
      </div>
    </PhoneMock>
  );
}
